import React, { useState, useEffect } from 'react'

import axios from 'axios'
import { Table } from 'antd'

import MonthlySubTable from '../Articoli/MonthlySubTable'
import MyResponsivePie from '../Articoli/Torta';

export default function ArticlesSubTable({ start, end, interval, negozi_columns, shop }) {

    const [data, setData] = useState([]);



    useEffect(() => {
        const fetchData = () => {
            setData(null);
            return axios
                .get(
                    `${process.env.REACT_APP_SERVER_URL}/api/dati/articles_interval?start=${start}&end=${end}&interval=${interval}`
                )
                .then((response) => {
                    console.log(response.data.articoli.buckets[0].negozi.buckets[0].per_negozio.buckets)

                    setData(response.data.articoli.buckets[0].negozi.buckets)
                })
                .catch((error) => {
                    console.log(error);
                })
                .then(() => {
                    // always executed
                });
        }
        const fetchOneShop = () => {
            setData(null);
            return axios
                .get(
                    `${process.env.REACT_APP_SERVER_URL}/api/dati/articles_interval/${shop}?start=${start}&end=${end}&interval=${interval}`
                )
                .then((response) => {
                    // let record = {
                    //     'key': shop,
                    //     'per_negozio': {
                    //         'buckets': response.data.articoli.buckets[0].negozi.buckets[0].per_negozio.buckets
                    //     }
                    // };

                    // console.log(response.data.articoli.buckets[0].negozi.buckets[0].per_negozio.buckets)

                    // // setData(response.data.articoli.buckets[0].negozi.per_negozio.buckets[0].articoli.buckets)
                    // // console.log([record])
                    // setData([record])
                    setData(response.data.articoli.buckets[0].negozi.buckets)

                })
                .catch((error) => {
                    console.log(error);
                })
                .then(() => {
                    // always executed
                });
        }
        // Run! Like go get some data from an API.

        if (shop === "all") {
            console.log('fetching all articles of all shops')
            fetchData()
        } else {
            console.log(`fetching articles of ${shop}`)
            fetchOneShop()
        }
    }, [interval, shop, end, start]);

    return (
        <div>

            <div id="analytics_torta">
                <MyResponsivePie start={start} end={end} shop={shop} />
            </div>


            <Table id="analytics_table" pagination={true} dataSource={data} expandable={{
                expandedRowRender: record => <MonthlySubTable pagination={true} data={record.per_negozio.buckets} negozio={record.key} interval={interval} />
            }} columns={negozi_columns} />
        </div>
    )
}
